import { makeStyles } from '@material-ui/core';

const LayoutStyles = makeStyles((theme) => ({
  root: {
    color: theme.colors.Text_1,
    margin: '0 auto',
    height: `calc(100% - 77px)`,
    width: '100vw',
    backgroundColor: theme.colors.Background_Primary,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: theme.spacing(0.5, 2),
    '&.full-h': {
      height: 'calc(100% + 64px)',
    },
    [theme.breakpoints.up('md')]: {
      height: `calc(100% - 92px)`,
      boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.05)',
      position: 'absolute',
      width: '100%',
      maxWidth: '1024px',
      margin: '8px auto',
      left: 0,
      right: 0,
      borderRadius: '8px',
      padding: theme.spacing(2),
    },
  },
}));

export default LayoutStyles;
